import { CredentialingContextProvider } from '@juvare/credentialing/ui/providers';
import React from 'react';

export const CredentialingProvider: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => {
    const [selectedPersonId, setSelectedPersonId] = React.useState<string | undefined>();

    return (
        <CredentialingContextProvider
            personId={selectedPersonId}
            slideoutMenuItems={[]}
            onPersonSelect={setSelectedPersonId}
            onPersonReset={() => setSelectedPersonId(undefined)}
        >
            {children}
        </CredentialingContextProvider>
    );
};
